import RouterUtils from '../../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import WorkerState from '../../../../../shared/model/WorkerState';

export class WorkerUpdateRequest {

    // WorkerContractorSave {
    //   id: number
    //   contractor_id: number
    //   document_schema_id: number
    // }

    _id; // number
    _dni; // string
    _name; // string
    _position; // string
    _lastName; // string
    _agreement; // string
    _companyId; // number
    _contractors; // WorkerContractorSave[]
    _workerStateId; // number

    constructor(values, worker) {
        this._id = worker.id();
        this._dni = values.dni;
        this._name = values.name;
        this._position = values.job;
        this._lastName = values.lastName;
        this._agreement = values.agreement;
        this._companyId = values.outsource[0] ? values.outsource[0].value : undefined;
        this._contractors = this._parseContractorSchemas(values, worker);
        this._workerStateId = values.state ? WorkerState.ACTIVE : WorkerState.INACTIVE;
    }

    url() {
        return RouterUtils.generateRoute(ApiEndpoints.WORKER_ID, { id: this._id });
    }

    body() {
        return {
            id: this._id,
            dni: this._dni,
            name: this._name,
            position: this._position,
            last_name: this._lastName,
            agreement: this._agreement,
            company_id: this._companyId,
            contractors: this._contractors,
            worker_state_id: this._workerStateId,
        };
    }

    _parseContractorSchemas(values, worker) {
        const { contractorId, contractorSchema } = values;
        const nextSchemas = {};
        const nextMySchema = contractorSchema[0];
        const workerDocumentation = worker.documentation();

        workerDocumentation
            .schemas()
            .forEach((s) => {
                nextSchemas[s.contractorId()] = {
                    contractor_id: s.contractorId(),
                    document_schema_id: s.documentSchemaId(),
                    position: s._position,
                };
            });

        if ( nextMySchema ) {
            nextSchemas[contractorId] = {
                contractor_id: contractorId,
                document_schema_id: nextMySchema.value,
                position: values.position,
            };
        } else {
            delete nextSchemas[contractorId];
        }

        return Object.values(nextSchemas);
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/update/worker-update/WorkerUpdateRequest.js